import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	DIMENSION_UNIT_SELECT_ITEMS,
	WEIGHT_UNIT_SELECT_ITEMS_WO_TON,
} from '../../../constants'
import CommonInput from '../../../common/Resusable/CommonInput'
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
import deleteIcon from '../../../assets/images/delete_icon_red.png'

const PACKING_TYPE_OPTIONS = [
	{ label: 'Select', value: 'Select' },
	{ label: 'DG UN Packaging', value: 'DG_UN_PACKAGING' },
	{ label: 'Metal boxes', value: 'METAL_BOXES' },
	{ label: 'Wooden boxes', value: 'WOODEN_BOXES' },
	{ label: 'Plywood boxes', value: 'PLYWOOD_BOXES' },
	{ label: 'Fibre board', value: 'FIBRE_BOARD' },
	{ label: 'Plastic box', value: 'PLASTIC_BOX' },
	{ label: 'No packaging', value: 'NO_PACKAGING' },
	{ label: 'Acft Engine on stand', value: 'ACFT_ENGINE_ON_STAND' },
]

const SlrPackagingRow = ({
	row,
	rowIndex,
	onChange,
	onRemove,
	canRemove = false,
	isStackable = null,
	isTiltable = null,
	isCraneLiftable = null,
	isForkLiftable = null,
	isFragile = null,
	errors = {},
	disableDimensionUnit = true,
}) => {
	const { t } = useTranslation(['labels', 'errors'])

	return (
		<div className='cargo-dimensions-row packaging-details-row'>
			<div className='form-row-dimensions mb-0'>
				{/* Pieces - enabled */}
				<div className='form-group'>
					<CommonInput
						type='text'
						label={t('COMMON.PCS')}
						value={row.pieces}
						onChange={(e) => {
							const value = e.target.value.replace(/[^0-9]/g, '')
							onChange('pieces', value)
						}}
						error={errors.pieces ? t(errors.pieces, { ns: 'errors' }) : ''}
					/>
				</div>

				{/* Length - enabled */}
				<div className='form-group'>
					<CommonInput
						type='text'
						label={t('COMMON.LN')}
						value={row.length}
						onChange={(e) => {
							const value = e.target.value.replace(/[^0-9.]/g, '')
							if (
								value.length <= 9 &&
								(!value.split('.')[1] || value.split('.')[1].length < 2) &&
								value.split('.').length <= 2
							) {
								onChange('length', value)
							}
						}}
						error={errors.length ? t(errors.length, { ns: 'errors' }) : ''}
					/>
				</div>

				{/* Width - enabled */}
				<div className='form-group'>
					<CommonInput
						type='text'
						label={t('COMMON.WD')}
						value={row.width}
						onChange={(e) => {
							const value = e.target.value.replace(/[^0-9.]/g, '')
							if (
								value.length <= 9 &&
								(!value.split('.')[1] || value.split('.')[1].length < 2) &&
								value.split('.').length <= 2
							) {
								onChange('width', value)
							}
						}}
						error={errors.width ? t(errors.width, { ns: 'errors' }) : ''}
					/>
				</div>

				{/* Height - enabled */}
				<div className='form-group'>
					<CommonInput
						type='text'
						label={t('COMMON.HT')}
						value={row.height}
						onChange={(e) => {
							const value = e.target.value.replace(/[^0-9.]/g, '')
							if (
								value.length <= 9 &&
								(!value.split('.')[1] || value.split('.')[1].length < 2) &&
								value.split('.').length <= 2
							) {
								onChange('height', value)
							}
						}}
						error={errors.height ? t(errors.height, { ns: 'errors' }) : ''}
					/>
				</div>

				{/* Dimension unit - disabled */}
				<CommonDropDown
					label={t('COMMON.UNIT_TYPE')}
					className='loose-dimension-unit-dropdown'
					value={row.dimensionUnit}
					options={DIMENSION_UNIT_SELECT_ITEMS}
					onChange={(e) => onChange('dimensionUnit', e.target.value)}
					disabled={disableDimensionUnit}
				/>
			</div>

			<div className='form-row-weight'>
				<div className='wght-left-section'>
					{/* Weight - enabled */}
					<div className={`form-group input-with-dropdown ${errors.weight ? 'red-border' : ''}`}>
						<CommonInput
							type='text'
							label={t('COMMON.WT_PER_PIECE')}
							value={row.weight}
							onChange={(e) => {
								const value = e.target.value.replace(/[^0-9.]/g, '')
								if (
									value.length <= 9 &&
									(!value.split('.')[1] || value.split('.')[1].length < 2) &&
									value.split('.').length <= 2
								) {
									onChange('weight', value)
								}
							}}
							error={errors.weight ? t(errors.weight, { ns: 'errors' }) : ''}
						/>
						<CommonDropDown
							value={row.weightUnit}
							options={WEIGHT_UNIT_SELECT_ITEMS_WO_TON}
							onChange={(e) => onChange('weightUnit', e.target.value)}
							isNoLabel
						/>
					</div>

					{/* Packing type - enabled dropdown */}
					<div className='form-group packing-type-slr'>
						<CommonDropDown
							value={row.packingType}
							options={PACKING_TYPE_OPTIONS.map((option) =>
								option.value === 'Select' ? { ...option, label: t('COMMON.SELECT') } : option
							)}
							onChange={(e) => onChange('packingType', e.target.value)}
							label={t('COMMON.PCKG_TYPE')}
							error={
								errors.packingType
									? t(errors.packingType, { ns: 'errors' })
									: ''
							}
						/>
					</div>
				</div>

				<div className='wght-right-section'></div>
			</div>

			<div className='cargo-pieceschkbox-row'>
				<div className='form-group packing-type'>
					<div className='chkbox-session'>
						<div className='l-checkbox' style={{ alignItems: 'center' }}>
							<input
								id={`non-stackable-${rowIndex}`}
								type='checkbox'
								checked={row.stackable === false}
								onChange={(e) => onChange('stackable', !e.target.checked)}
								disabled={isStackable === true}
							/>
							<label className='mb-0' htmlFor={`non-stackable-${rowIndex}`}>
								{t('BOOKING.SLR_NON_STACKABLE')}
							</label>
						</div>
						<div className='l-checkbox' style={{ alignItems: 'center' }}>
							<input
								id={`non-tiltable-${rowIndex}`}
								type='checkbox'
								checked={row.turnable === false}
								onChange={(e) => onChange('turnable', !e.target.checked)}
								disabled={isTiltable === true}
							/>
							<label className='mb-0' htmlFor={`non-tiltable-${rowIndex}`}>
								{t('BOOKING.SLR_NON_TILTABLE')}
							</label>
						</div>
						<div className='l-checkbox' style={{ alignItems: 'center' }}>
							<input
								id={`non-crane-liftable-${rowIndex}`}
								type='checkbox'
								checked={row.craneLiftable === false}
								onChange={(e) => onChange('craneLiftable', !e.target.checked)}
								disabled={isCraneLiftable === true}
							/>
							<label
								className='mb-0'
								htmlFor={`non-crane-liftable-${rowIndex}`}
							>
								{t('BOOKING.SLR_NON_CRANE_LIFTABLE')}
							</label>
						</div>
						<div className='l-checkbox' style={{ alignItems: 'center' }}>
							<input
								id={`non-fork-liftable-${rowIndex}`}
								type='checkbox'
								checked={row.forkLiftable === false}
								onChange={(e) => onChange('forkLiftable', !e.target.checked)}
								disabled={isForkLiftable === true}
							/>
							<label className='mb-0' htmlFor={`non-fork-liftable-${rowIndex}`}>
								{t('BOOKING.SLR_NON_FORK_LIFTABLE')}
							</label>
						</div>
						<div className='l-checkbox' style={{ alignItems: 'center' }}>
							<input
								id={`fragile-${rowIndex}`}
								type='checkbox'
								checked={row.fragile === true}
								onChange={(e) => onChange('fragile', e.target.checked)}
								disabled={isFragile === true}
							/>
							<label className='mb-0' htmlFor={`fragile-${rowIndex}`}>
								{t('BOOKING.SLR_ROW_FRAGILE')}
							</label>
						</div>
					</div>
				</div>
				{canRemove && (
					<div className='delete-section ml-auto' onClick={onRemove}>
						<img src={deleteIcon} alt='Trash' title='Trash' id='Trash-icon' />
						<span>{t('COMMON.REMOVE')}</span>
					</div>
				)}
			</div>
		</div>
	)
}

export default SlrPackagingRow
